export enum MenuType {
    SIDEBAR = "SIDEBAR",
    CONFIGURATION = "CONFIGURATION"
}